import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Header, Page, ObjetoAvatar, SecaoGenerica } from 'components'
import { Card, CardContent, CircularProgress, Divider, Grid, Typography, Link } from '@material-ui/core'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { CardCaso } from 'components/Cards/CardCaso'
import { CardExameSolicitado } from 'components/Cards/CardExameSolicitado'
import useRouter from 'utils/useRouter'
import { MenuAcoes } from './componentes/MenuAcoes'

import PersonIcon from '@material-ui/icons/Person'
import BusinessIcon from '@material-ui/icons/Business'
import AssignmentIcon from '@material-ui/icons/Assignment'
import ScheduleIcon from '@material-ui/icons/Schedule'

import { useStyles } from './FichaSolicitacaoExames.styles'
import { ExibirArquivo } from 'components/ExibirArquivo'
import { ListaInformacoes } from 'views/Informacao/ListaInformacoes'
import { useParams } from 'react-router'
import { HistoricoOperacoes } from 'components/HistoricoOperacoes'

export const FichaSolicitacaoExame = (props) => {
  const { route } = props
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const params = useParams()
  const router = useRouter()
  const solicitacaoExameService = useSolicitacaoExameService()
  const [processandoSolicitacoesExame, setProcessandoSolicitacoesExames] = useState(false)
  const [solicitacoesExame, setSolicitacoesExames] = useState(null)
  const [showMore, setShowMore] = useState(false)

  useEffect(() => {
    const fetchSolicitacaoExame = async () => {
      const result = await solicitacaoExameService.listarSolicitacaoExameAsync(params.id, setProcessandoSolicitacoesExames)
      setSolicitacoesExames(result)
    }
    fetchSolicitacaoExame()
  }, [params.id])

  const handleClickCaso = (id, novaAba) => {
    if (novaAba) {
      window.open(`/casos/caso/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/detalhar/${id}`)
    }
  }

  const getTextoDocumento = (descricaoDocumento) => {
    if (!descricaoDocumento) return 'SEM DESCRIÇÃO ADICIONADA'
    if (descricaoDocumento.length <= 200) return descricaoDocumento.toUpperCase()
    if (showMore) return descricaoDocumento.toUpperCase()
    const regex = RegExp("^(?:.*\\r?\\n){5}", 'd')
    const match = regex.exec(descricaoDocumento)
    if (match) {
      const endIndex = match.indices[0][1]
      return descricaoDocumento.substring(0, endIndex).toUpperCase() + (descricaoDocumento.length > endIndex ? '...' : '')
    }
    return descricaoDocumento.substring(0, 200).toUpperCase() + (descricaoDocumento.length > 200 ? '...' : '')
  }

  const handleClickExameSolicitado = (id) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${id}`)
  }

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao}`} overline={route.secao} />
      {processandoSolicitacoesExame || !solicitacoesExame ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div className={classes.resultsWrapper}>
          {/* Cabeçalho Premium da Solicitação */}
          <Card className={classes.headerCard}>
            <CardContent style={{ padding: '24px' }}>
              <Grid container spacing={3} alignItems="center" justifyContent="space-between">
                <Grid item xs={12} sm={6} md={7} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <ObjetoAvatar tipo="SOLICITACAO" />
                  <Typography variant="h3" className={classes.caseTitle}>
                    {solicitacoesExame.numeroDocumento ? `NÚMERO: ${solicitacoesExame.numeroDocumento.toUpperCase()}` : 'SEM NÚMERO'}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {!processandoSolicitacoesExame && (
                    <MenuAcoes idSolicitacaoExame={params.id} />
                  )}
                </Grid>
              </Grid>

              <Divider style={{ margin: '20px 0 24px 0' }} />

              <Grid container item xs={12}>
                <Typography variant="subtitle1" className={classes.caseSubtitle} style={{marginTop: 0, marginBottom: '24px', whiteSpace: 'pre-wrap' }}>
                  {getTextoDocumento(solicitacoesExame.descricaoDocumento)}
                  {solicitacoesExame.descricaoDocumento?.length > 200 && (
                  <Link href="#" variant="subtitle1" style={{marginLeft: "5px"}} onClick={() => setShowMore(!showMore)}>
                    {showMore ? 'Mostrar menos' : 'Mostrar mais'}
                  </Link>
                )}
                </Typography>
              </Grid>

              <Grid container spacing={3} className={classes.metaGrid} alignItems="stretch">
                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <PersonIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>AUTORIDADE SOLICITANTE</Typography>
                      <Typography className={classes.metaValue}>
                        {solicitacoesExame?.autReq?.nome?.toUpperCase() === 'OUTRO'
                          ? solicitacoesExame?.autoridadeRequisitanteInput?.toUpperCase() || '-'
                          : solicitacoesExame.autReq?.nome?.toUpperCase() || '-'}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <BusinessIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>SETOR SOLICITANTE</Typography>
                      <Typography className={classes.metaValue}>
                        {solicitacoesExame.setReq ? solicitacoesExame.setReq?.nome?.toUpperCase() : 'NÃO INFORMADO'}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <AssignmentIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>DESTINO DO EXAME</Typography>
                      <Typography className={classes.metaValue}>
                        {solicitacoesExame.setDest
                          ? `${solicitacoesExame.setDest?.nome?.toUpperCase()} / ${solicitacoesExame.setDest?.divisao?.sigla?.toUpperCase()}`
                          : 'NÃO INFORMADO'}
                      </Typography>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <div className={classes.metaItem}>
                    <ScheduleIcon className={classes.metaIcon} />
                    <div className={classes.metaTextContainer}>
                      <Typography className={classes.metaLabel}>DATA DA SOLICITAÇÃO</Typography>
                      <Typography className={classes.metaValue}>
                        {moment(solicitacoesExame.data).format('DD/MM/YYYY HH:mm')}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Dados do Documento */}
          <SecaoGenerica titulo="Dados do Documento de Solicitação">
            <Grid container spacing={3}>
              <Grid item md={4} sm={6} xs={12}>
                <Typography className={classes.metaLabel}>TIPO DE DOCUMENTO</Typography>
                <Typography className={classes.metaValue}>
                  {solicitacoesExame.tipoDocumento?.toUpperCase() || 'NÃO INFORMADO'}
                </Typography>
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <Typography className={classes.metaLabel}>NÚMERO DO DOCUMENTO</Typography>
                <Typography className={classes.metaValue}>
                  {solicitacoesExame.numeroDocumento || 'NÃO INFORMADO'}
                </Typography>
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <Typography className={classes.metaLabel}>TIPO DE PROCEDIMENTO</Typography>
                <Typography className={classes.metaValue}>
                  {solicitacoesExame.tipoProc?.nome?.toUpperCase() || 'NÃO INFORMADO'}
                </Typography>
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <Typography className={classes.metaLabel}>NÚMERO DO PROCEDIMENTO</Typography>
                <Typography className={classes.metaValue}>
                  {solicitacoesExame.numeroProcedimento || 'NÃO INFORMADO'}
                </Typography>
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <Typography className={classes.metaLabel}>INDICIADO</Typography>
                <Typography className={classes.metaValue}>
                  {solicitacoesExame.indiciado?.toUpperCase() || 'NÃO INFORMADO'}
                </Typography>
              </Grid>


            </Grid>
          </SecaoGenerica>

          {/* Informações Adicionadas */}
          <SecaoGenerica titulo="Informações Adicionadas">
            <Grid item xs={12}>
              <ListaInformacoes tipo="solicitacaoExame" id={solicitacoesExame.id} />
            </Grid>
          </SecaoGenerica>

          {/* Caso Relacionado */}
          <SecaoGenerica titulo="Caso Relacionado">
            {solicitacoesExame.caso ? (
              <Grid container spacing={2}>
                <Grid item md={3} sm={6} xs={12}>
                  <CardCaso caso={solicitacoesExame.caso} handleClick={handleClickCaso} />
                </Grid>
              </Grid>
            ) : (
              <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                <Typography variant="body2" color="textSecondary">Nenhum caso associado</Typography>
              </Grid>
            )}
          </SecaoGenerica>

          {/* Exames Solicitados */}
          <SecaoGenerica titulo="Exames Solicitados">
            {solicitacoesExame.exSols && solicitacoesExame.exSols.length ? (
              <Grid container spacing={2}>
                {solicitacoesExame.exSols.map((exameSolicitado) => (
                  <Grid item md={3} sm={6} xs={12} key={exameSolicitado.id}>
                    <CardExameSolicitado exameSolicitado={exameSolicitado} handleClick={handleClickExameSolicitado} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                <Typography variant="body2" color="textSecondary">Nenhum exame solicitado</Typography>
              </Grid>
            )}
          </SecaoGenerica>

          {/* Arquivos Relacionados */}
          <SecaoGenerica titulo="Arquivos Relacionados">
            {solicitacoesExame.arqs && solicitacoesExame.arqs.length ? (
              <Grid container spacing={2}>
                {solicitacoesExame.arqs.map((arquivo) => (
                  <Grid item md={2} sm={4} xs={6} key={arquivo.id} className={classes.item}>
                    <ExibirArquivo id={arquivo.id} rotaLoadFile="/arquivo/caso" />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid container justifyContent="center" alignItems="center" style={{ padding: '30px 0' }}>
                <Typography variant="body2" color="textSecondary">Nenhum arquivo relacionado</Typography>
              </Grid>
            )}
          </SecaoGenerica>

          {/* Histórico de Operações */}
          <SecaoGenerica titulo="Histórico de Operações">
            <Grid item xs={12} style={{ paddingTop: '10px' }}>
              <HistoricoOperacoes id={params.id} tipo="SOLICITACAO_EXAME" />
            </Grid>
          </SecaoGenerica>
        </div>
      )}
    </Page>
  )
}
